import React, {Component} from 'react';
import { Platform, View, Image, Text, FlatList, StyleSheet,
         UIManager, findNodeHandle, TouchableHighlight, TouchableOpacity } from 'react-native';
import Icon from "react-native-vector-icons/Ionicons";
import MessageBox from "../ui/MessageBox";
import RoomClient from "../../utils/chinesepark/RoomClient";
import AVPermission from "../../utils/chinesepark/AVPermission";
import AppConfig from "../../config/AppConfig";
import IsMobile from "../../utils/IsMobile";
import * as Helper from "../../utils/Helper";
import FlagIconsHelper from "../../utils/chinesepark/FlagIconsHelper";
import { Button, } from "native-base";
import { withTranslation } from "react-i18next";
//import FastImage from 'react-native-fast-image';
import AudioIcon from "./AudioIcon";
import VideoIcon from "./VideoIcon";
import UIDs from "../../UIDs";
import _ from 'lodash';
/*
import RtcEngine, {
    ChannelProfile,
    ChannelMediaOptions,
    ClientRole,
    RtcChannel,
    RtcEngineConfig,
    RtcLocalView,
    RtcRemoteView,
} from 'react-native-agora';
*/

import challenge1_icon from "../../images/challenge1.png";
import challenge2_icon from "../../images/challenge2.png";
import usermenu_icon from "../../images/user_menu.png";

const uid = UIDs.screens.chinesepark.room;

class VideoView extends Component {
    constructor(props) {
        super(props);
        var userid = RoomClient.videoUserId(this.props.index);
        var uin = RoomClient.videoUin(this.props.index);
        var flags = RoomClient.videoFlags(this.props.index);
        this.state = {
            userid: userid,
            uin: uin,
            flags: flags,
            isManager: userid ? RoomClient.getUser(userid).isManager : false,
            audioTrack: null,
            videoTrack: null,
        };

        this.setupButtonRef = this.setupButtonRef.bind(this);
        this.setupVideo = this.setupVideo.bind(this);
        this.onUser = this.onUser.bind(this);
        this.onStartVideo = this.onStartVideo.bind(this);
        this.onStopVideo = this.onStopVideo.bind(this);
        this.onToggleAudio = this.onToggleAudio.bind(this);
        this.onToggleVideo = this.onToggleVideo.bind(this);
        this.onUserPublished = this.onUserPublished.bind(this);
        this.onUserUnpublished = this.onUserUnpublished.bind(this);
        this.onLocalPublished = this.onLocalPublished.bind(this);
        this.onLocalUnpublished = this.onLocalUnpublished.bind(this);
    }

    componentDidMount() {
        if (this.props.engine) {
            this.initEngine(this.props.engine);
            this.updateMediaTracks();
        }

        RoomClient.events.addListener("onUser", this.onUser);
        RoomClient.events.addListener("startVideo", this.onStartVideo);
        RoomClient.events.addListener("stopVideo", this.onStopVideo);
        RoomClient.events.addListener("onLocalPublished", this.onLocalPublished);
        RoomClient.events.addListener("onLocalUnpublished", this.onLocalUnpublished);
        RoomClient.events.addListener("user-published", this.onUserPublished);
        RoomClient.events.addListener("user-unpublished", this.onUserUnpublished);
    }

    componentWillUnmount() {
        RoomClient.events.removeListener("onUser", this.onUser);
        RoomClient.events.removeListener("startVideo", this.onStartVideo);
        RoomClient.events.removeListener("stopVideo", this.onStopVideo);
        RoomClient.events.removeListener("onLocalPublished", this.onLocalPublished);
        RoomClient.events.removeListener("onLocalUnpublished", this.onLocalUnpublished);
        RoomClient.events.removeListener("user-published", this.onUserPublished);
        RoomClient.events.removeListener("user-unpublished", this.onUserUnpublished);
        this.uninitEngine();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.engine !== this.props.engine) {
            this.uninitEngine();
            if (this.props.engine) {
                this.initEngine(this.props.engine);
            }
            this.updateMediaTracks();
        }
    }

    initEngine(engine) {
        this._engine = engine;
    }

    uninitEngine() {
        if (!this._engine) {
            return;
        }

        delete this._engine;
    }

    setupButtonRef(r) {
        this._button = r;
    }

    setupVideo(r) {
        this._videoElement = r;
        if (this._videoElement) {
            this.updateMediaTracks();
        }
    }

    onUserPublished(user, mediaType) {
        if (user.uid === this.state.uin) {
            this.updateMediaTracks();
        }
    }

    onUserUnpublished(user, mediaType) {
        if (user.uid === this.state.uin) {
            this.updateMediaTracks();
        }
    }

    onLocalPublished() {
        if (this.state.userid === RoomClient.userid) {
            this.updateMediaTracks();
        }
    }

    onLocalUnpublished() {
        if (this.state.userid === RoomClient.userid) {
            this.updateMediaTracks();
        }
    }

    updateMediaTracks() {
        if (!this._engine) {
            this.audioTrack = null;
            this.videoTrack = null;
            this.setState({audioTrack: this.audioTrack, videoTrack: this.videoTrack});
            return;
        }

        if (this.state.userid === RoomClient.userid) {
            if (this.audioTrack && this.audioTrack !== this._engine._localAudioTrack) {
                this.audioTrack.stop();
            }
            if (this.videoTrack && this.videoTrack !== this._engine._localVideoTrack) {
                this.videoTrack.stop();
            }
            this.audioTrack = this._engine._localAudioTrack;
            this.videoTrack = this._engine._localVideoTrack;
            if (this.videoTrack && this._videoElement) {
                this.videoTrack.play(this._videoElement);
            }
            this.setState({audioTrack: this.audioTrack, videoTrack: this.videoTrack});
            return;
        }

        var remoteUser = this._engine.remoteUsers.find(user => user.uid === this.state.uin);
        if (remoteUser) {
            if (this.audioTrack && this.audioTrack !== remoteUser.audioTrack) {
                this.audioTrack.stop();
            }
            if (this.videoTrack && this.videoTrack !== remoteUser.videoTrack) {
                this.videoTrack.stop();
            }
            this.audioTrack = remoteUser.audioTrack;
            this.videoTrack = remoteUser.videoTrack;
            if (this.audioTrack) {
                this.audioTrack.play();
            }
            if (this.videoTrack && this._videoElement) {
                this.videoTrack.play(this._videoElement);
            }
        }
        else {
            if (this.audioTrack) {
                this.audioTrack.stop();
            }
            if (this.videoTrack) {
                this.videoTrack.stop();
            }
            this.audioTrack = null;
            this.videoTrack = null;
        }

        this.setState({audioTrack: this.audioTrack, videoTrack: this.videoTrack});
    }

    onUser(user) {
        if (user.uid === this.state.userid) {
            if (this.state.isManager !== user.isManager) {
                this.setState({isManager: user.isManager});
            }
        }
    }

    onStartVideo(video) {
        if (video.index !== this.props.index)
            return;

        this.setState({userid: video.userid, uin: video.uin, flags: video.flags,
                       isManager: (video.userid ? RoomClient.getUser(video.userid).isManager : false)},
                      () => {
                          this.updateMediaTracks();
                      });
    }

    onStopVideo(video) {
        if (video.index !== this.props.index)
            return;

        this.setState({userid: 0, uin: 0, flags: 0, isManager: false},
                      () => {
                          this.updateMediaTracks();
                      });
    }

    async startMic() {
        if (!await AVPermission.checkPermission(this.props.t)) {
            return;
        }

        RoomClient.startMic({vindex: this.props.index}, (resp) => {
            if (resp.error) {
                if (resp.message === 'noRemainMinutes') {
                    this.props.onNoRemainMinutes();
                    return;
                }
                if (resp.message === 'invalidRoomType') {
                    return;
                }
                MessageBox.show({
                    text: this.props.t(resp.message),
                    position: "top",
                    duration: 5000
                });
            }
        });
    }

    launchPK() {
        this.props.onLaunchPK();
    }

    acceptPK() {
        this.props.onAcceptPK(this.props.index);
    }

    updateMic(add_flags, del_flags) {
        var args = {
            vindex: this.props.index,
            add_flags: add_flags,
            del_flags: del_flags,
        };
        RoomClient.updateMic(args, (rep) => {
            if (rep.error) {
                console.warn('updateMic: ' + JSON.stringify(rep));
                MessageBox.show({
                    text: this.props.t(rep.message),
                    position: "top",
                    duration: 5000
                });
                //RoomClient.events.emit("error", rep.message);
            }
            else {
                console.log('updateMic: ' + JSON.stringify(rep));
            }
        });
    }

    onToggleAudio() {
        if (this.state.userid === RoomClient.userid) {
            if (!AVPermission.microphone) {
                return;
            }
        }

        if (this.props.roomInfo.roomType === RoomClient.ROOM_TYPE_PK) {
            // PK模式不能关闭麦克风
            return;
        }

        if (this.state.flags & RoomClient.MIC_AUDIO_CLOSE) {
            this.updateMic(0, RoomClient.MIC_AUDIO_CLOSE);
        }
        else {
            this.updateMic(RoomClient.MIC_AUDIO_CLOSE, 0);
        }
    }

    onToggleVideo() {
        if (this.state.userid === RoomClient.userid) {
            if (!AVPermission.camera) {
                return;
            }
        }

        if (this.state.flags & RoomClient.MIC_VIDEO_CLOSE) {
            this.updateMic(0, RoomClient.MIC_VIDEO_CLOSE);
        }
        else {
            this.updateMic(RoomClient.MIC_VIDEO_CLOSE, 0);
        }
    }

    renderNoUser(containerStyle) {
        const isMobile = IsMobile();
        if (this.props.isPK) {
            const { pkstate, pkinfo } = this.props;
            if (0 === this.props.index) {
                if (pkstate.state === RoomClient.PK_STATE_INIT) {
                    const canLaunch = (this.props.roomInfo.ownerId === RoomClient.userid) || this.props.isManager || this.props.roomInfo.challengeType;
                    return (<View style={containerStyle}>
                                <TouchableOpacity style={{flex: 1}}
                                                  onPress={() => {
                                                      if (!canLaunch) {
                                                          MessageBox.show({
                                                              text: this.props.t('onlyOwnerAndManagerCanLaunch'),
                                                              position: "top",
                                                              duration: 5000
                                                          });
                                                          return;
                                                      }
                                                      this.launchPK();
                                                  }}>
                                    <View style={{flex: 1, flexDirection: 'column',
                                                  backgroundColor: '#0070dd',
                                                  alignItems: 'center', justifyContent: 'center'}}>
                                        <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                                            <Icon name="ios-add" style={{ fontSize: (isMobile ? 20 : 16), color: "#fff", marginRight: 4 }} />
                                            <Text style={{fontSize: (isMobile ? 14 : 10), color: '#fff'}}>{this.props.t('launchPK')}</Text>
                                        </View>
                                    </View>
                                </TouchableOpacity>
                                {this.renderPKRole()}
                            </View>
                           );
                }
            }

            if ((pkstate.state === RoomClient.PK_STATE_WAIT) &&
                (this.props.index >= RoomClient.getPKPersons()))
            {
                // PK模式空白位置
                return (<View style={containerStyle}>
                            <View style={{flex: 1, flexDirection: 'column', backgroundColor: '#dedede'}}>
                                <View style={{flexDirection: 'row', flex: 1, backgroundColor: '#a7a7a7',
                                              alignItems: 'center', justifyContent: 'center'}}>
                                </View>
                            </View>
                        </View>
                       );
            }

            if (pkstate.state === RoomClient.PK_STATE_WAIT) {
                var canAccept = (RoomClient.getPKMyRole() === -1);
                const { title } = pkstate.subject || {};
                return (<View style={containerStyle}>
                            <TouchableOpacity style={{flex: 1}} disabled={!canAccept}
                                              onPress={() => this.acceptPK()}>
                                <View style={{flex: 1, flexDirection: 'column',
                                              backgroundColor: (canAccept ? '#0070dd' : '#a7a7a7'),
                                              alignItems: 'center', justifyContent: 'center'}}>
                                    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                                        <Icon name="ios-add" style={{ fontSize: (isMobile ? 20 : 16), color: "#fff", marginRight: 4 }} />
                                        <Text style={{fontSize: (isMobile ? 14 : 10), color: '#fff'}}>{this.props.t('acceptPK')}</Text>
                                    </View>
                                    {title ?
                                     (<Text numberOfLines={1} ellipsizeMode={'tail'}
                                            style={{ fontSize: (isMobile ? 14 : 10), color:"#fff", maxWidth: '90%' }}>
                                          ({title})
                                      </Text>) : null}
                                </View>
                            </TouchableOpacity>
                            {this.renderPKRole()}
                        </View>
                       );
            }
            return (<View style={containerStyle}>
                    <View style={{flex: 1, flexDirection: 'column', backgroundColor: '#dedede'}}>
                    <View style={{flexDirection: 'row', flex: 1, backgroundColor: '#a7a7a7',
                                  alignItems: 'center', justifyContent: 'center'}}>
                        <Text style={{fontSize: (isMobile ? 14 : 10), color: '#fff'}}>{this.props.t('waitForJoin')}</Text>
                    </View>
                        {/*
                    <View style={{height: 28, backgroundColor: '#dedede'}}/>
                         */}
                    </View>
                    {this.renderPKRole()}
                    </View>
                   );
        }

        const bigFont = ((!isMobile) && this.props.mode === 'talk');
        return (<View style={containerStyle}>
                    <TouchableOpacity style={{flex: 1}} onPress={() => this.startMic()}>
                        <View style={{flexDirection: 'row', flex: 1,
                                      backgroundColor: (isMobile ? '#3e3e3e' : '#252631'),
                                      alignItems: 'center', justifyContent: 'center'}}>
                            <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                                <Icon name="ios-add" style={{ fontSize: (bigFont ? 24 : 20), color: "#fff", marginRight: 4 }} />
                                <Text style={{fontSize: (bigFont ? 18 : 14), color: '#fff'}}>
                                    {this.props.t('upMic')}
                                </Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                </View>
        );
    }

    renderUserIcon() {
        let userid = this.state.userid;
        if ((!userid) && this.props.isPK) {
            userid = RoomClient.pkstate.dialogUsers[this.props.index].uid;
        }

        const icon = RoomClient.getUser(userid).icon;
        if (!icon) {
            return null;
        }
        if (icon.isUseAvatar) {
            return (<View style={{flex: 1, alignItems: 'center', justifyContent: 'center',
                                  backgroundColor: icon.avatarBackgroundColor}}>
                    <Text style={{fontSize: 60, color: '#fff'}}>{icon.avatarName}</Text>
                    </View>);
        }
        return (<Image style={{flex: 1}} resizeMode={'cover'}
                source={{uri: Helper.convertToAbsoluteUrl(icon.photo)}}/>);
    }

    renderLocalView() {
        if (this.props.mediaTest) {
            return null;
        }
        if (this.state.flags & (RoomClient.MIC_VIDEO_CLOSE | RoomClient.MIC_VIDEO_NOPERM)) {
            if (this.videoTrack) {
                this.videoTrack.stop();
                return null;
            }
            return this.renderUserIcon();
        }
        return (<View ref={this.setupVideo} style={{flex: 1, backgroundColor: '#000'}}/>);
    }

    renderRemoteView() {
        if (!this.state.userid) {
            return null;
        }
        if (this.state.flags & (RoomClient.MIC_VIDEO_CLOSE | RoomClient.MIC_VIDEO_NOPERM)) {
            if (this.videoTrack) {
                this.videoTrack.stop();
                return null;
            }
            return this.renderUserIcon();
        }
        return (<View ref={this.setupVideo} style={{flex: 1, backgroundColor: '#000'}}/>);
    }

    renderAudioIcon(hasPerm) {
        let style = {zIndex: 2, position: 'absolute',
                     left: 4, bottom: 4, width: 20, height: 20};
        if (this.props.videoPerRow > 2) {
            /*
            style = {zIndex: 2, position: 'absolute',
                     right: 4, top: 4, width: 20, height: 20};
            */
        }
        return (<AudioIcon style={style}
                           uid={(this.state.userid === RoomClient.userid) ? 0 : this.state.uin}
                           engine={this.props.engine}
                           audioTrack={this.state.audioTrack}
                           disabled={this.state.flags & (RoomClient.MIC_AUDIO_CLOSE | RoomClient.MIC_AUDIO_NOPERM)}
                           onPress={hasPerm ? this.onToggleAudio : undefined}/>);
    }

    renderOwnerIcon() {
        let offset = AppConfig.ENABLE_CHINESE_PARK_VIDEO ? 24 : 0;
        let style = {zIndex: 2, position: 'absolute',
                     alignItems: 'center', justifyContent: 'center',
                     left: offset + 28, bottom: 4, width: 20, height: 20,
                     borderWidth: StyleSheet.hairlineWidth, borderColor: '#ccc',
                     borderRadius: 12, backgroundColor: 'white'};
        if (this.props.videoPerRow > 2) {
            /*
            style = {zIndex: 2, position: 'absolute',
                     alignItems: 'center', justifyContent: 'center',
                     right: 28, top: 4, width: 20, height: 20,
                     borderWidth: StyleSheet.hairlineWidth, borderColor: '#ccc',
                     borderRadius: 12, backgroundColor: 'white'};
            */
        }
        return (<View style={style}>
                    <Image style={{width: 16, height: 16}}
                           resizeMode='contain'
                           source={require('../../images/chinesepark/owner.png')}/>
                </View>);
    }

    renderVideoIcon(hasPerm) {
        let style = {zIndex: 2, position: 'absolute',
                     left: 28, bottom: 4, width: 20, height: 20};
        if (this.props.videoPerRow > 2) {
            /*
            style = {zIndex: 2, position: 'absolute',
                     right: 28, top: 4, width: 20, height: 20};
            */
        }
        return (<VideoIcon style={style}
                disabled={this.state.flags & (RoomClient.MIC_VIDEO_CLOSE | RoomClient.MIC_VIDEO_NOPERM)}
                onPress={hasPerm ? this.onToggleVideo : undefined}/>);
    }

    renderMenuIcon(hasPerm) {
        if (!hasPerm)
            return null;

        /*
        if (this.props.isPK)
            return null;
        */
        return (<View style={{zIndex: 1, position: 'absolute', top: 4, right: 4, width: 24, height: 24}}
                ref={this.setupButtonRef} onLayout={() => {}}>
                    <TouchableOpacity style={{width: '100%', height: '100%'}} onPress={() => {
                                          if (this._button) {
                                              const handle = findNodeHandle(this._button);
                                              UIManager.measure(handle, (x, y, width, height, pageX, pageY) => {
                                                  this.props.onUserMenu(this.state.userid, pageX + width, pageY + height);
                                              });
                                          }
                                      }}>
                        <Image style={{width: '100%', height: '100%'}} source={usermenu_icon}/>
                    </TouchableOpacity>
                </View>);
    }

    getCountryIcon(code) {
        return FlagIconsHelper.getFlagIconSource(code);
    }

    getPKBadgeIcon(badge) {
        switch (badge) {
        case 1:
            return require('../../images/chinesepark/badges/1.png');
        case 2:
            return require('../../images/chinesepark/badges/2.png');
        case 3:
            return require('../../images/chinesepark/badges/3.png');
        case 4:
            return require('../../images/chinesepark/badges/4.png');
        case 5:
            return require('../../images/chinesepark/badges/5.png');
        case 6:
            return require('../../images/chinesepark/badges/6.png');
        case 7:
            return require('../../images/chinesepark/badges/7.png');
        }
        return require('../../images/chinesepark/badges/1.png');
    }

    getUserColor(user) {
        if (user.isRoomVip && user.isSiteVip) {
            return '#1AD9AC';
        }
        if (user.isRoomVip) {
            return '#00d3eb';
        }
        if (user.isSiteVip) {
            return '#ffb007';
            //return '#fefc00';
        }

        if (this.props.lightMode) {
            return '#000000';
        }
        return '#ffffff';
    }

    renderUserName() {
        let userid = this.state.userid;
        if (!userid) {
            if (this.props.isPK && RoomClient.pkstate.dialogUsers[this.props.index].uid) {
                userid = RoomClient.pkstate.dialogUsers[this.props.index].uid;
            }
        }

        const user = RoomClient.getUser(userid);
        const color = this.getUserColor(user);
        const countryIcon = this.getCountryIcon(user.country);
        const badgeIcon = this.getPKBadgeIcon(user.pkBadge);
        let maxWidth = this.props.videoWidth - 18 - 14 - 8 - 2 - 4 - 4;
        if (/*this.props.videoPerRow <= 2*/true) {
            maxWidth -= 24;
            if (AppConfig.ENABLE_CHINESE_PARK_VIDEO) {
                maxWidth -= 24;
            }
            if (user.isOwner || this.state.isManager) {
                maxWidth -= 24;
            }
        }
        if (user.isSiteVip) {
            maxWidth -= 14;
        }
        if (user.isRoomVip) {
            maxWidth -= 14;
        }
        return (<View style={{zIndex: 1, position: 'absolute', bottom: 4, right: 4,
                              height: 20, flexDirection: 'row',
                              alignItems: 'center', justifyContent: 'center', borderRadius: 12,
                              paddingLeft: 4, paddingRight: 4, backgroundColor: 'rgba(0,0,0,0.5)'}}>
                    <Image style={{width: 16, height: 12}} resizeMode='contain' source={countryIcon}/>
                    <Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain' source={badgeIcon}/>
                    {user.isSiteVip ?
                     (<Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain'
                             source={require('../../images/chinesepark/vip.png')}/>) : null}
                    {user.isRoomVip ?
                     (<Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain'
                             source={require('../../images/chinesepark/roomvip.png')}/>) : null}
                    <Text ellipsizeMode="tail" numberOfLines={1}
                          style={{marginLeft: 2, fontSize: 12, color: color, maxWidth: maxWidth}}>
                        {RoomClient.getUser(userid).name}
                    </Text>
                </View>)
    }

    renderUserNamePC() {
        let userid = this.state.userid;
        if (!userid) {
            if (this.props.isPK && RoomClient.pkstate.dialogUsers[this.props.index].uid) {
                userid = RoomClient.pkstate.dialogUsers[this.props.index].uid;
            }
        }

        const user = RoomClient.getUser(userid);
        const color = this.getUserColor(user);
        const countryIcon = this.getCountryIcon(user.country);
        const badgeIcon = this.getPKBadgeIcon(user.pkBadge);
        let maxWidth = this.props.videoWidth - 18 - 14;
        if (/*this.props.videoPerRow <= 2*/false) {
            maxWidth -= 24;
            if (user.isOwner || this.state.isManager) {
                maxWidth -= 24;
            }
        }
        if (user.isSiteVip) {
            maxWidth -= 14;
        }
        if (user.isRoomVip) {
            maxWidth -= 14;
        }
        return (<View style={{height: 24, flexDirection: 'row', alignItems: 'center'}}>
                    <Image style={{width: 18, height: 12}} resizeMode='contain' source={countryIcon}/>
                    <Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain' source={badgeIcon}/>
                    {user.isSiteVip ?
                     (<Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain'
                             source={require('../../images/chinesepark/vip.png')}/>) : null}
                    {user.isRoomVip ?
                     (<Image style={{marginLeft: 2, width: 12, height: 12}} resizeMode='contain'
                             source={require('../../images/chinesepark/roomvip.png')}/>) : null}
                    <Text ellipsizeMode="tail" numberOfLines={1}
                          style={{marginLeft: 2, fontSize: 12, color: color, maxWidth: maxWidth}}>
                        {RoomClient.getUser(userid).name}
                    </Text>
                </View>)
    }

    renderPKRole() {
        const { pkstate, pkinfo } = this.props;
        const isLaunch = (pkstate.state === RoomClient.PK_STATE_INIT) && (this.props.index === 0);
        const isMobile = IsMobile();
        return (<View style={{position: 'absolute', left: 0, top: 0,
                              zIndex: 10, paddingLeft: 2, paddingRight: 2,
                              paddingTop: 2, paddingBottom: 2,
                              flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
                              color: '#fff', backgroundColor: '#fab22e'}}>
                    <Image style={{width: (isMobile ? 10 : 8),
                                   height: (isMobile ? 10 : 8),
                                   marginRight: 2}} source={isLaunch ? challenge1_icon : challenge2_icon}/>
                    <Text style={{fontSize: (isMobile ? 11 : 10), color: '#fff'}}>{isLaunch ? this.props.t('lanch') : this.props.t('acept')}</Text>
                </View>);
    }

    renderGiveupLayer() {
        return (<View style={{zIndex: 100, position: 'absolute',
                              left: 0, top: 0, right: 0, bottom: 0,
                              alignItems: 'center', justifyContent: 'center',
                              backgroundColor: 'rgba(0,0,0,0.6)'}}>
                    <Text style={{fontSize: 16, color: '#fff'}}>{this.props.t('giveUpPK')}</Text>
                </View>);
    }

    renderPKView() {
        // PK模式只能自己关自己的麦
        const isMobile = IsMobile();
        const { pkstate, pkinfo } = this.props;
        const hasPerm = (this.state.userid === RoomClient.userid);
        const text = this.props.t("all({{all}})win({{win}})",
                                  {all: pkinfo.pkAll || 0,
                                   win: pkinfo.pkWins || 0});
        const user = RoomClient.getUser(this.state.userid);
        return (<View style={{flex: 1, backgroundColor: '#333333'}}>
                <View style={{flex: 1}}>
                {this.state.userid ? ((this.state.userid === RoomClient.userid) ?
                                      this.renderLocalView() : this.renderRemoteView()) : this.renderUserIcon()}
                {this.state.userid ? this.renderAudioIcon(false) : null}
                {(user.isOwner || this.state.isManager) ? this.renderOwnerIcon() : null}
                {this.state.userid && AppConfig.ENABLE_CHINESE_PARK_VIDEO ? this.renderVideoIcon(hasPerm) : null}
                {this.state.userid ? this.renderMenuIcon(hasPerm) : null}
                {isMobile ? this.renderUserName() : null}
                {(pkstate.state > RoomClient.PK_STATE_INIT) ? this.renderPKRole() : null}
                {(!this.state.userid) ? this.renderGiveupLayer() : null}
                </View>
                {/*
                <View style={{alignItems: 'center', justifyContent: 'center',
                              height: 28, backgroundColor: '#dedede'}}>
                <Text style={{fontSize: 13, color: '#333'}}>{text}</Text>
                </View>
                 */}
                </View>);
    }

    renderTalkView() {
        const user = RoomClient.getUser(this.state.userid);
        const isMobile = IsMobile();
        var hasPerm = (this.state.userid === RoomClient.userid);
        var hasAudioPerm = hasPerm;
        var hasVideoPerm = hasPerm;
        if ((!hasPerm)/* && (!user.isOwner)*/) {
            if (RoomClient.isRoomOwner() || RoomClient.isRoomManager()) {
                // 房主只有关闭权限, 没有打开权限
                hasPerm = true;
                hasAudioPerm = !(this.state.flags & (RoomClient.MIC_AUDIO_CLOSE | RoomClient.MIC_AUDIO_NOPERM));
                hasVideoPerm = !(this.state.flags & (RoomClient.MIC_VIDEO_CLOSE | RoomClient.MIC_VIDEO_NOPERM));
            }
        }
        return (<View style={{flex: 1, backgroundColor: '#333333'}}>
                {(this.state.userid === RoomClient.userid) ?
                 this.renderLocalView() : this.renderRemoteView()}
                {this.renderAudioIcon(hasAudioPerm)}
                {(user.isOwner || this.state.isManager) ? this.renderOwnerIcon() : null}
                {AppConfig.ENABLE_CHINESE_PARK_VIDEO ? this.renderVideoIcon(hasVideoPerm) : null}
                {this.renderMenuIcon(hasPerm)}
                {isMobile ? this.renderUserName() : null}
                </View>);
    }

    renderEduView() {
        const user = RoomClient.getUser(this.state.userid);
        const isMobile = IsMobile();
        var hasPerm = (this.state.userid === RoomClient.userid);
        var hasAudioPerm = hasPerm;
        var hasVideoPerm = hasPerm;
        if ((!hasPerm)/* && (!user.isOwner)*/) {
            if (RoomClient.isRoomOwner() || RoomClient.isRoomManager()) {
                // 房主只有关闭权限, 没有打开权限
                hasPerm = true;
                hasAudioPerm = !(this.state.flags & (RoomClient.MIC_AUDIO_CLOSE | RoomClient.MIC_AUDIO_NOPERM));
                hasVideoPerm = !(this.state.flags & (RoomClient.MIC_VIDEO_CLOSE | RoomClient.MIC_VIDEO_NOPERM));
            }
        }
        return (<View style={{flex: 1, backgroundColor: '#333333', overflow: 'hidden',
                              borderRadius: isMobile ? undefined : 3,
                              borderWidth: isMobile ? undefined : 1,
                              borderColor: isMobile ? undefined : '#62636b'}}>
                {(this.state.userid === RoomClient.userid) ?
                 this.renderLocalView() : this.renderRemoteView()}
                {this.renderAudioIcon(hasAudioPerm)}
                {(user.isOwner || this.state.isManager) ? this.renderOwnerIcon() : null}
                {AppConfig.ENABLE_CHINESE_PARK_VIDEO ? this.renderVideoIcon(hasVideoPerm) : null}
                {this.renderMenuIcon(hasPerm)}
                {isMobile ? this.renderUserName() : null}
                </View>);
    }

    render() {
        if (!this.state.userid) {
            var style = {flex: 1};
            if (!IsMobile()) {
                if (this.props.mode === 'edu') {
                    style = {
                        flex: 1,
                        overflow: 'hidden',
                        borderRadius: 3,
                        borderWidth: 1,
                        borderColor: '#62636b',
                    };
                }
            }

            if (this.props.isPK && RoomClient.pkstate.dialogUsers[this.props.index].uid) {
            }
            else {
                return (<View style={this.props.style}>
                            {this.renderNoUser(style)}
                            <View style={{height: 24}}/>
                        </View>);
            }
        }
        return (<View style={this.props.style}>
                    {this.props.mode === 'talk' ? this.renderTalkView() : null}
                    {this.props.mode === 'pk' ? this.renderPKView() : null}
                    {this.props.mode === 'edu' ? this.renderEduView() : null}
                    {IsMobile() ? null : this.renderUserNamePC()}
                    {(this.state.flags & RoomClient.MIC_USER_LEAVE) ?
                     (<View style={{position: 'absolute', left: 0, top: 0, right: 0,
                                    bottom: (IsMobile() ? 0 : 24),
                                    zIndex: 1, alignItems: 'center', justifyContent: 'center',
                                    backgroundColor: 'rgba(0,0,0,0.5)'}}>
                          <Text style={{color: '#fff'}}>{this.props.t('userLeave')}</Text>
                      </View>) : null}
                </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});

export default withTranslation(uid, { withRef: true })(VideoView);
